<template>
  <div
    class="app-spinner"
  >
    <div>
      <div>
        <div :style="{ textTransform: 'center', fontWeight: 600, fontSize: $fontSizes[6], marginBottom: '2rem' }">
          You will be redirected to Notion shortly...
        </div>
      </div>
      <div :style="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }">
        <img
          src="/favicon.svg"
          alt="Notix logo"
          :style="{ width: '8rem', height: 'auto', marginRight: '2rem' }"
        >
        <div :style="{ marginRight: '2rem' }">
          <c-icon
            type="arrow-go-forward"
            size="20"
            :color="$colors.grey.base"
          />
          <c-icon
            type="arrow-go-forward"
            :style="{ transform: 'rotate(180deg)' }"
            size="20"
            :color="$colors.grey.base"
          />
        </div>
        <img
          src="/notion-logo.svg"
          alt="Notion logo"
          :style="{ width: '8rem', height: 'auto' }"
        >
      </div>
      <c-icon
        v-if="error === ''"
        type="loading"
        spin
        :style="{ marginTop: '3rem' }"
        size="30"
        :color="$colors.grey.base"
      />
      <div
        v-else
        :style="{ display: 'flex', justifyContent: 'center', marginTop: '3rem' }"
      >
        <c-button
          color="primary"
          :style="{ minWidth: '20rem'}"
          @click="retry"
        >
          Retry
        </c-button>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CIcon from 'shared/components/CIcon.vue';
import { USER_SERVICE } from 'shared/constants';
import { httpsCallable } from 'shared/services/firebase';
import reportHandledError from 'shared/services/report-error';
import { provide } from 'vue';

import useCurrentUser from '@/services/user';

export default {
  name: 'ConnectToNotion',
  setup() {
    const userService = useCurrentUser();
    provide(USER_SERVICE, userService);
    return { currentUser: userService.currentUser, loading: userService.loading };
  },
  components: { CIcon, CButton },
  data() {
    return { error: '' };
  },
  methods: {
    retry() {
      this.error = '';
      this.connectToNotion();
    },
    async getNotionAuthURL() {
      const notionAuthURL = httpsCallable(this.$functions, 'notionAuthURL');
      const res = await notionAuthURL();
      return res.data;
    },
    async connectToNotion() {
      this.connectLoading = true;
      try {
        const res = await this.getNotionAuthURL();
        window.location.href = res;
      } catch (e) {
        reportHandledError(e, { where: 'notion auth url' });
        this.$eventBus.emit('show-toast', {
          type: 'error',
          message: 'An error occurred while trying to connect to Notion.',
        });
        this.error = e;
      }
    },
  },
  created() {
    this.connectToNotion();
  },
};
</script>

<style scoped lang="scss" type="text/scss">
</style>
